import { useState } from 'react';

export const usePagination = (pageCount: number) => {
  const [currentPage, setPage] = useState(0);
  const [perPage, setPerPage] = useState(pageCount);

  return { currentPage, perPage, setPage, setPerPage };
};
